var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0531 7.4511C16.7357 5.74974 16.7357 2.98146 15.0531 1.2801C14.2371 0.45458 13.1515 0 11.9968 0C11.9965 0 11.9965 0 11.9965 0C10.8418 0 9.75587 0.45458 8.93953 1.2801L8.15753 2.0706L7.37553 1.2801C6.55919 0.45458 5.47357 0 4.31859 0C3.16395 0 2.07833 0.45458 1.26199 1.2801C-0.420665 2.98146 -0.420665 5.74974 1.26199 7.4511L8.15753 14.4235L15.0531 7.4511ZM1.74547 1.75814C2.43295 1.06284 3.34721 0.68 4.31859 0.68C5.29031 0.68 6.20457 1.06284 6.89205 1.75814L8.15753 3.0379L9.42301 1.75814C10.1105 1.06284 11.0248 0.68 11.9965 0.68C12.9682 0.68 13.8821 1.06284 14.5696 1.75814C15.9918 3.196 15.9918 5.5352 14.5696 6.97306L8.15753 13.4565L1.74547 6.97306C0.323255 5.5352 0.323255 3.19566 1.74547 1.75814Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavIcon);
export default __webpack_public_path__ + "static/media/FavIcon.f9681e2e706d91a50ab42b1abc3dc5c2.svg";
export { ForwardRef as ReactComponent };